import { FeatureType, Features } from '@lessonPlanner/constants';

import { routes } from './routes';

export const routeToFeatureMap = {
  [routes.MAIN]: Features.LESSON_PLAN,
  [routes.CATCH_UP_FRIDAYS]: Features.CATCH_UP_FRIDAYS,
  [routes.SUMMATIVE_TEST]: Features.SUMMATIVE_TEST,
  [routes.ACTIVITIES]: Features.ACTIVITIES,
  [routes.QUIZMAKER]: Features.QUIZMAKER,
  [routes.SUBJECT_EXTENSIONS]: Features.SUBJECT_EXTENSIONS,
  [routes.ANALOGY]: Features.ANALOGY,
  [routes.DLL]: Features.DLL,
  [routes.LEARNING_COMPETENCY]: Features.OBJECTIVES,
  [routes.TOPIC_EXPLORER]: Features.TOPIC_EXPLORER,
  [routes.ENERGIZER]: Features.ENERGIZER,
  [routes.ELIF]: Features.ELIF,
  [routes.PHOTO_BOOTH]: Features.PHOTO_BOOTH,
  [routes.UNIT_PLAN]: Features.UNIT_PLAN,
  [routes.PPT_MAKER]: Features.PPT_MAKER,
  [routes.CEREBRO_LESSON_PLAN]: Features.CEREBRO_TEACHING_GUIDE,
  [routes.GENERIC_UNPACKING]: Features.GENERIC_UNPACKING,
  [routes.IPLAN_OBJECTIVE]: Features.IPLAN_OBJECTIVES,
  [routes.MULTIGRADE_LESSON_PLAN]: Features.MULTIGRADE_LESSON_PLAN,
};

export const routeToFeatureType = {
  [routes.MAIN]: FeatureType.LESSON_PLANNER,
  [routes.CATCH_UP_FRIDAYS]: FeatureType.CATCH_UP_FRIDAYS,
  [routes.SUMMATIVE_TEST]: FeatureType.SUMMATIVE_TEST,
  [routes.ACTIVITIES]: FeatureType.ACTIVITY,
  [routes.QUIZMAKER]: FeatureType.SHORT_QUIZ,
  [routes.SUBJECT_EXTENSIONS]: FeatureType.LWAC,
  [routes.ANALOGY]: FeatureType.ANALOGY,
  [routes.DLL]: FeatureType.DLL,
  [routes.LEARNING_COMPETENCY]: FeatureType.OBJECTIVES,
  [routes.TOPIC_EXPLORER]: FeatureType.TOPIC_EXPLORER,
  [routes.ENERGIZER]: FeatureType.ENERGIZER,
  [routes.ELIF]: FeatureType.ELIF,
  [routes.UNIT_PLAN]: FeatureType.UNIT_PLAN,
  [routes.PPT_MAKER]: FeatureType.PPT_MAKER,
  [routes.CEREBRO_LESSON_PLAN]: FeatureType.CEREBRO_LESSON_PLAN,
  [routes.GENERIC_UNPACKING]: FeatureType.GENERIC_UNPACKING,
  [routes.IPLAN_OBJECTIVE]: FeatureType.IPLAN_OBJECTIVES,
  [routes.MULTIGRADE_LESSON_PLAN]: FeatureType.MULTIGRADE_LESSON_PLAN,
};
